module.exports = __webpack_public_path__ + "media/images/getting-started/editing-first-link-8bc05b91933528d9aa6b31bd42a85e7d.gif";